export default {
  faqs: state => state.faqs,
  faq: state => state.faq
}
